import type { ComponentInit } from "@scripts/registry";
import { createTrack } from "@scripts/track";

const TRACK = "[data-fa-fixture-breakdown-track]";
const ITEM = "[data-fa-fixture-breakdown-item]";
const PREV = '[data-fa-fixture-breakdown-arrow="prev"]';
const NEXT = '[data-fa-fixture-breakdown-arrow="next"]';

export const initFixtureBreakdown: ComponentInit = (root) => {
	const track = root.querySelector<HTMLElement>(TRACK);
	const prev = root.querySelector<HTMLElement>(PREV);
	const next = root.querySelector<HTMLElement>(NEXT);

	if (!track || !prev || !next) return;

	return createTrack({ track, prev, next, item: ITEM });
};
